// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__3gymy","icon-instagram":"icon-instagram__ae7ex","icon-twitter":"icon-twitter__2V2qK","icon-pinterest":"icon-pinterest__10nFw"};


//////////////////
// WEBPACK FOOTER
// ./components/Parts/FormattedLink.scss
// module id = Rn9J
// module chunks = 0